import { Row, Skeleton } from '@fs/zion-ui'
import React from 'react'
import { useChangelogParams } from '../../../changelogRouteUtil'
import SubHeader from './SubHeader'

export default function ContributionsActionBarSkeleton(): JSX.Element {
  const { relationshipId } = useChangelogParams()

  return (
    <Row alignY="middle" guttersX="sm">
      <SubHeader />

      <div growX />
      {!relationshipId && <Skeleton.Button emphasis="medium" minWidth={100} data-testid="filter-button-skeleton" />}
    </Row>
  )
}
